import { ICompanyAddViewModel, ICompanyViewModel, ThirdPartEnum } from 'Interfaces/ICompaniesConfig';
import { EnumCompanyType, EnumPriority } from 'Interfaces/IGlobalTypeConfig';

export const ToCompanies = (data: any): ICompanyAddViewModel[] => {
  if (!data.results) return [];
  console.log('NEW : companies: før', data);
  let newList: ICompanyAddViewModel[] = [];
  data.results.forEach((company: any) => {
    let newListItem: ICompanyAddViewModel = {
      organizationNumber: '',
      alias: company.alias || '',
      name: company.name,
      mainAddress: {
        street: company.address.streetName,
        postalCode: company.address.postalCode,
        area: 'Bergen',
        city: company.address.city,
        country: 'Norway',
        postBox: '',
      },
      deliveryAddress: null,
      invoiceAddress: null,
      phone: company.phone,
      email: company.email,
      supportEmail: '',
      companyType: EnumCompanyType.CLIENT,
      webPage: '',
      fileModel: null,
      productBilling: false,
      onHold: false,
      isSupport: false,
      onHoldNote: company.externalServices.MICROSOFT,
      priority: EnumPriority.NORMAL,
      fixedHourlyRate: 0,
      workRoleId: null,
      contactId: null,
      companyProducts: [],
      productCatalog: [],
      storageProducts: [],
      unassignedCompanyProducts: [],
      legacyId: company.legacyId,
      thirdPartyId: company.id,
      thirdParty: company.CloudFactory,
      creatorId: null,
    };
    newList.push(newListItem);
  });
  console.log('NEW : companies: etter', newList);
  return newList;
};

export const ToCompanyAdd = (data: ICompanyViewModel): ICompanyAddViewModel => {
  return {
    organizationNumber: '',
    alias: data.alias || '',
    name: data.name,
    mainAddress: {
      street: data.mainAddress.street,
      postalCode: data.mainAddress.postalCode,
      area: data.mainAddress.area || 'Bergen',
      city: data.mainAddress.city,
      country: data.mainAddress.country || 'Norway',
      postBox: '',
    },
    deliveryAddress: null,
    invoiceAddress: null,
    phone: data.phone,
    email: data.email,
    supportEmail: '',
    companyType: EnumCompanyType.CLIENT,
    webPage: data.webPage || '',
    fileModel: null,
    productBilling: data.productBilling || false,
    onHold: data.onHold || false,
    isSupport: data.isSupport || false,
    onHoldNote: data.onHoldNote || '',
    priority: data.priority || EnumPriority.NORMAL,
    fixedHourlyRate: data.fixedHourlyRate || 0,
    workRoleId: data.workRole?.id || null,
    contactId: data.contactId || null,
    companyProducts: data.companyProducts || [],
    productCatalog: [],
    storageProducts: [],
    unassignedCompanyProducts: [],
    legacyId: data.legacyId || 0,
    thirdPartyId: data.thirdPartyId || '',
    thirdParty: data.thirdParty || ThirdPartEnum.CloudFactory,
    creatorId: data.creatorId || null,
  };
}